<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="stock" />
        <MenuStockList/>
        <PurchaseOrderList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import PurchaseOrderList from '@/components/menuadmin/stock/stocklist/PurchaseOrderList.vue'

export default {
    name:'purchaseOrder',
    components:{
        HeaderStock,
        MenuStockList,
        PurchaseOrderList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>